import React, { forwardRef, useImperativeHandle, useEffect, useState } from "react";
import { endpoints } from "../constants/env/middletier";
import { Dropdown } from 'primereact/dropdown';


const ClientsDropdown = forwardRef(function ClientsDropdown(
  { onGetClients },
  ref
) {
// function GroupsDropdown({ onGetGroup }) {
  const [clients, setClients] = useState([]);
  const [groupsList, setGroupsList] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedGroupSubs, setSelectedGroupSubs] = useState(null);
  const [loading, setLoading] = useState(true);
    const [selectedSubs, setSelectedSubs] = useState(null);

    useImperativeHandle(ref, () => ({
        async reset() {
            try {
                const res = await fetch(Endpoints["client"]);
                const data = await res.json();
                setClients(data);
                console.log("Data Clients");
                console.log(data);
            } catch (err) {
                console.error("Failed to load clients", err);
            } finally {
                setLoading(false);
            }
        }
    }));

  // Fetch all groups on mount
  useEffect(() => {
    async function fetchClients() {
      try {
        const res = await fetch(Endpoints["client"]);
        const data = await res.json();

        const options = data.map(client => ({
          label: client.name,
          value: client.id
        }));

        setClients(options);
        console.log("Data Clients");
        console.log(data);
        console.log(options);
      } catch (err) {
        console.error("Failed to load clients", err);
      } finally {
        setLoading(false);
      }
    }
    fetchClients();
  }, []);

  const handleClientChange = (e) => {
    const clientName = e.target.value;
    const client = clients.find((g) => g.name === clientName);
    setSelectedClient(e.value);
    onGetClients(e.value);
//    setSelectedGroupSubs(group.substitutes);
  };

    const setGroupName = (e) => {
        setSelectedSubs(e.value)
        onGetPhoneNumbers(e.value);
    }




  if (loading) return <div>Loading data...</div>;

  return (
    <>
        <div className="card flex justify-content-center">
            <Dropdown
                value={selectedClient}
                onChange={handleClientChange}
                options={clients}
                optionLabel="label"
                placeholder="Select Client" />
        </div>
    </>
  );
});

export default ClientsDropdown;
